import React from 'react';
import { Column, Row } from '../../../../components/Grid';
import { Image, ImageZoom } from '../../../../components/Image';
import { Section } from '../../../../components/Section';
import { TypoImage } from '../../../../components/TypoImage';
import {
  withBreakpoints,
  WithBreakpointsProps
} from '../../../../provider/BreakpointProvider/withBreakpoints';
import { ModalContext } from '../../../../provider/ModalProvider';
import {
  CType
} from '../../../../provider/Typo3Provider/types';
import { media } from '../../../../theme/base/mixins';

const TwoImagesSection = Section.extend`
  ${Column} {
    margin-bottom: ${props => props.theme.grid.columnGap}px;

    ${media.medium`
      margin-bottom: 0;
    `};
  }
`;

const mkTwoImages = ({
  files = { image: [] },
  breakpoints
}: CType & WithBreakpointsProps) => {
  const images = files.image || [];
  const { medium } = breakpoints;
  return (
    <TwoImagesSection>
      <Row>
        {images.map((image, index) => (
          <Column key={index} small={12} medium={6} large={6}>
            {medium && image.imageZoomUri ? (
              <ModalContext.Consumer>
                {({ showModal }) => (
                  <ImageZoom
                    onClick={() => {
                      showModal(<Image src={image.imageZoomUri} />, {
                        zoom: true
                      });
                    }}
                  >
                    <TypoImage image={image} />
                  </ImageZoom>
                )}
              </ModalContext.Consumer>
            ) : (
              <TypoImage image={image} />
            )}
          </Column>
        ))}
      </Row>
    </TwoImagesSection>
  );
};

export const TwoImages = withBreakpoints(mkTwoImages);

export const ImageContent = ({ files = { image: [] } }: CType) => {
  const images = files.image || [];
  return (
    <Section>
      <Row>
        {images.map((image, index) => (
          <Column key={index}>
            <TypoImage image={image} />
          </Column>
        ))}
      </Row>
    </Section>
  );
};

export const ImageFull = ({ files = { image: [] } }: CType) => {
  const images = files.image || [];
  return (
    <Section noPadding>
      {images.map((image, index) => (
        <TypoImage image={image} key={index} />
      ))}
    </Section>
  );
};
